import { ToastContainer } from "react-toastify";
import Loader from "./components/Loader";
import Router from "./routing/Router";
import "react-toastify/dist/ReactToastify.css";
import ReactGA from "react-ga4";

function App() {
  ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);
  return (
    <>
      <Router />
      <Loader />
      <ToastContainer />
    </>
  );
}

export default App;
